<table>
  <thead>
    <tr>
      @for (column of displayedColumns; track column) {
        <th (click)="orderBy(column.name)">
          <span [style.visibility]="orderProperties().column == column.name ? 'visible' : 'hidden'">
            {{ orderProperties().asc ? '▲' : '▼' }}
          </span>
          {{column.title}}
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (item of (items() | orderBy: orderProperties()); track item.id) {
      <tr
        (dblclick)="itemDoubleClick(item)"
        (click)="itemClick($event, item)"
        [attr.selected]="isSelected(item) ? true : null"
        [attr.itemId]="item.id"
        draggable="true"
        [cdkContextMenuTriggerFor]="bookmarkMenu.menu.menu"
        (contextmenu)="contextMenuBookmark = item">
        @for (column of displayedColumns; track column) {
          <td>
            @if (column.name === 'title') {
              @if (item.url) {
                <img alt="" [src]="getFavicon(item)" />
              } @else {
                <app-folder-icon [item]="item"></app-folder-icon>
              }
            }
            {{getColumnValue(item, column.name)}}
          </td>
        }
      </tr>
    }
  </tbody>
</table>

<app-bookmark-menu #bookmarkMenu [bookmark]="contextMenuBookmark"></app-bookmark-menu>
